import { Button, Container, Link as MuiLink } from "@mui/material";
import { AppContext } from "Contexts/AppContext";
import { useContext, useState } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { getResourceURL } from "Utils/S3Utils";
import CentralizedLayout from "./CentralizedLayout";

declare global {
    namespace JSX {
        interface IntrinsicElements {
            "model-viewer": ModelViewerAttributes;
        }
        interface ModelViewerAttributes {
            id?: string;
            src?: string;
            "shadow-intensity"?: string;
            ar?: any;
            "camera-controls"?: any;
            "touch-action"?: string;
            alt?: string;
            "animation-name"?: string;
            autoplay?: any;
            children?: Element;
        }
    }
}

const AvatarsPage: React.FC<any> = () => {
    const [avatar, setAvatar] = useState(
        getResourceURL("models/avatars/AV_01.glb")
    );
    const navigate = useNavigate();
    const appConfig = useContext(AppContext);
    const onAvatarSelected = (e: any, avatar: string) => {
        const modelViewerElement = document.getElementById("avatars-viewer");
        const avatarURL = getResourceURL(`models/avatars/${avatar}.glb`);
        modelViewerElement?.setAttribute("src", avatarURL);
        setAvatar(avatarURL);
    };

    const onBWLandLaunched = () => {
        const BWLAND = (window as any).BWLAND;
        console.log(avatar);
        if (!appConfig.scene) {
            navigate("/");
        } else {
            const user = {
                uid: appConfig.profile?.id,
                displayName: `${appConfig.profile?.firstName} ${appConfig.profile?.lastName}`,
                photoURL: appConfig.profile?.photoURL,
                email: appConfig.profile?.email,
                avatar,
            };

            // Unmount app and load BWLAnd
            const root = document.getElementById("root");
            root!.parentNode?.removeChild(root!);

            const bwlandNode = document.getElementById("bwland");
            bwlandNode?.removeAttribute("style");

            //
            new BWLAND[appConfig.scene]({
                user,
            });
        }
    };

    return (
        <CentralizedLayout>
            <Container
                className="avatars-selection"
                disableGutters={true}
                maxWidth={false}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "baseline",
                    height: "100vh",
                }}
            >
                <div id="avatars-selector" className="slider">
                    <div className="slides">
                        {[
                            "AV_01",
                            "AV_02",
                            "AV_03",
                            "AV_04",
                            "AV_05",
                            "CV_01",
                            "CV_02",
                            "CV_03",
                            "CV_04",
                            "CX_01",
                        ].map((avatar: string) => (
                            <Button
                                key={avatar}
                                className="slide"
                                style={{
                                    backgroundImage: `url("assets/images/avatars/${avatar}.png")`,
                                }}
                                onClick={(e) => {
                                    onAvatarSelected(e, avatar);
                                }}
                            ></Button>
                        ))}
                    </div>
                </div>
                <Container
                    disableGutters={true}
                    maxWidth={false}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                    }}
                >
                    <model-viewer
                        src={avatar}
                        id="avatars-viewer"
                        shadow-intensity="1"
                        ar
                        camera-controls
                        touch-action="pan-y"
                        alt="A 3D model carousel"
                        animation-name="Walking"
                        autoplay
                    >
                        <div
                            style={{
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                right: 0,
                            }}
                        >
                            <MuiLink
                                href={"#"}
                                className="bw-bgcolor"
                                sx={{
                                    borderRadius: 1,
                                    py: "0.6rem",
                                    columnGap: "1rem",
                                    textDecoration: "none",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontWeight: 500,
                                    "&:hover": {
                                        className: "bw-color",
                                        boxShadow:
                                            "0 1px 13px 0 rgb(0 0 0 / 55%)",
                                    },
                                    mb: 8,
                                }}
                                display="flex"
                                justifyContent="center"
                                alignItems="flex-end"
                                onClick={onBWLandLaunched}
                            >
                                {/* <GoogleLogo style={{ height: "2rem" }} /> */}
                                Launch BWLand
                            </MuiLink>
                        </div>
                    </model-viewer>
                </Container>
            </Container>
        </CentralizedLayout>
    ); //
};
export default AvatarsPage;
